import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: "#1976D2",
    secondary: "#26A69A",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#00E676",
    search: "#1976D2",
    select: "#1976D2",
    warning: "#FFB74D",
    besetblue: "#1E88E5",
    wplgrey0: "#e6e7e8",
    wplgrey1: "#4d4d4f",
    wplwhite0: "#f6f6f6",
    wplred0: "#d71638",
    wplblue0: "#001543",
    wplblue1: "#003369",
    wplblue2: "#0071bc",
    wplblue3: "#00aeef",
    wplblue4: "#90d1f3",
    wplblue5: "#e1f4fd",
    wplorange0: "#f58220",
    wplyellow0: "#ffd400",
    wplgreen0: "#51b848",
    wplgreen1: "#005f2a",
    changeSettings: "#FFA726"
  }
});
